// these sizes are arbitrary and you can set them to whatever you wish
import {css} from 'styled-components'
import {media} from '../mixins/responsive'

export const widthDisplay = ({display, displaySm, displayMd, displayLg}) => {

    return css`
        ${display && `display: ${display};`} 
        ${
        media.tablet`${displaySm && `display: ${displaySm};`}}`
        }
        ${
        media.desktop`${displayMd && `display: ${displayMd};`}}`
        }

        ${
        media.giant`${displayLg && `display: ${displayLg};`}`
        }`

}
